/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import './ATBNeedToKnow.css';

//TODO: If ATB changes pricing, the information need to be updated
export function ATBNeedToKnow({ className }) {
    return (
        <div className={`atb-need-to-know ${className || ''}`}>
            <div className="atb-need-to-know__title">
                America the Beautiful Passes cover the entrance fee and non-resident fee
                at this location
            </div>
            <div className="atb-need-to-know__content">
                <span className="atb-need-to-know__text">
                    If you are traveling with non-residents or visiting more than one
                    federal recreation area, an annual or lifetime pass may save you
                    money. The{' '}
                </span>
                <a
                    href={`${process.env.SITE_ROOT}/interagency-pass/types/resident`}
                    className="atb-need-to-know__link"
                >
                    Resident Annual Pass ($80)
                </a>
                <span className="atb-need-to-know__text">, </span>
                <a
                    href={`${process.env.SITE_ROOT}/interagency-pass/types/nonresident`}
                    className="atb-need-to-know__link"
                >
                    Non-Resident Annual Pass ($250)
                </a>
                <span className="atb-need-to-know__text">, and other </span>
                <a
                    href={`${process.env.SITE_ROOT}/pass`}
                    className="atb-need-to-know__link"
                >
                    annual or lifetime passes
                </a>
                <span className="atb-need-to-know__text">
                    {' '}
                    cover the entrance fee and non-resident fees at this location.
                </span>
            </div>
        </div>
    );
}
